import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONCODINGS_LOAD,
    ACTION_INSTITUTIONCODINGS_LOAD_BY_ID,

    ACTION_INSTITUTIONCODINGS_SAVE,

    ACTION_INSTITUTIONCODINGS_CREATE,

    ACTION_INSTITUTIONCODINGS_VALIDATE,

    IInstitutionCodingLoadAction,
    IInstitutionCodingLoadByIdAction,
    IInstitutionCodingLoadFailureAction,
    IInstitutionCodingLoadSuccessAction,

    IInstitutionCodingSaveAction,
    IInstitutionCodingSaveSuccessAction,
    IInstitutionCodingSaveFailureAction,

    IInstitutionCodingCreateAction,
    IInstitutionCodingCreateSuccessAction,
    IInstitutionCodingCreateFailureAction,

    IInstitutionCodingValidateAction,
    IInstitutionCodingValidateSuccessAction,
    IInstitutionCodingValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionCoding";
import { institutionCodingsApi } from "../services/institutionCodings";


export const
    getInstitutionCodingsEpic = (action$): Observable<IInstitutionCodingLoadSuccessAction | IInstitutionCodingLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODINGS_LOAD)
            .mergeMap((_action: IInstitutionCodingLoadAction) => {
                return institutionCodingsApi
                    .getInstitutionCodings()
                    .map(response =>
                        LoadSuccess(response.institutionCodings, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionCodingByIdEpic = (action$): Observable<IInstitutionCodingLoadSuccessAction | IInstitutionCodingLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODINGS_LOAD_BY_ID)
            .mergeMap((action: IInstitutionCodingLoadByIdAction) => {
                return institutionCodingsApi
                    .getInstitutionCodingById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionCoding, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionCodingEpic = (action$): Observable<IInstitutionCodingSaveSuccessAction | IInstitutionCodingSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODINGS_SAVE)
            .mergeMap((action: IInstitutionCodingSaveAction) => {
                return institutionCodingsApi
                    .setInstitutionCoding(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionCoding, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionCodingEpic = (action$): Observable<IInstitutionCodingCreateSuccessAction | IInstitutionCodingCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODINGS_CREATE)
            .mergeMap((_action: IInstitutionCodingCreateAction) => {
                return institutionCodingsApi
                    .createInstitutionCoding()
                    .map(response =>
                        CreateSuccess(
                            response.institutionCoding,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionCodingEpic = (action$): Observable<IInstitutionCodingValidateSuccessAction | IInstitutionCodingValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODINGS_VALIDATE)
            .mergeMap((action: IInstitutionCodingValidateAction) => {
                return institutionCodingsApi
                    .validateInstitutionCoding(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionCoding, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



